var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54748 6.4553C5.1566 3.60801 5.96116 2.18436 7.06518 1.81789C7.67255 1.61628 8.3268 1.61628 8.93417 1.81789C10.0382 2.18436 10.8428 3.60801 12.4519 6.4553C14.061 9.3026 14.8655 10.7262 14.6242 11.8863C14.4914 12.5244 14.1643 13.1033 13.6897 13.5398C12.827 14.3334 11.2179 14.3334 7.99967 14.3334C4.78144 14.3334 3.17232 14.3334 2.30965 13.5398C1.83506 13.1033 1.50793 12.5244 1.37516 11.8863C1.1338 10.7262 1.93836 9.3026 3.54748 6.4553Z",
    stroke: "#EBBE65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99401 10.6667H8",
    stroke: "#EBBE65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.66669L8 6.00002",
    stroke: "#EBBE65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.186240f628cda808570ad6145ee32125.svg";
export { ForwardRef as ReactComponent };